@use "../../../globals/settings";
@use "../../../globals/bcp-2022/objects/links";

:host {
  display: inline-flex;
}

a:not([class]),
a[class=""] {
  @include links.inline;
}

.a-link {
  @include links.standalone;

  &--primary {
    @include links.primary;
  }

  &--disabled {
    @include links.disabled;
  }

  &--with-parts {
    @include links.with-icon();
  }
}

// ------------------- CUSTOM -----------------------------------------------------------------------------------------
// ...
